import { Box, useMediaQuery } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import GenerateGoogleUsersButton from "./GenerateGoogleUsersButton";
import GoogleUsersListButton from "./GoogleUsersListButton";
import { SectionTitle } from "features/SectionTitle";

/**
 * Google Workspace accounts for the campaign's remote-exam candidates. Mountable on any campaign Show page —
 * it renders nothing unless the campaign actually has a remote exam.
 */
const GoogleUsersSection = ({ campaignId, exams, isFinished }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const hasRemoteExam = exams?.some(exam => exam.isRemoteExamType);

  if (!campaignId || !hasRemoteExam) return null;

  return (
    <>
      <SectionTitle
        title="Google акаунти"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Box
        sx={{
          ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox),
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
        }}
      >
        <SecuredComponent permission={permissions.canManageCandidateGoogleUsers}>
          <GenerateGoogleUsersButton
            campaignId={campaignId}
            disabled={isFinished}
          />
        </SecuredComponent>
        <SecuredComponent permission={permissions.canPreviewCandidateGoogleUsers}>
          <GoogleUsersListButton campaignId={campaignId} />
        </SecuredComponent>
      </Box>
    </>
  );
};

export default GoogleUsersSection;
